import React, { useState } from "react";
import { RefetchProvider, useDebounce } from "@piiqtechnologies/ui-lib";
import { PeekGrid, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import { Outlet } from "react-router-dom";
import SearchText from "@components/common/search-text";
import { useIntl } from "react-intl";
import { messages } from "./messages.i18n";
import AppHeader from "@components/app-header";
import { Dedupe } from "@piiqtechnologies/svg-icons";
export const DedupeUnitsLayout = () => {
    const intl = useIntl();
    const [searchKey, setSearchKey] = useState(null);
    const debouncedSearchKey = useDebounce(searchKey, 700);
    const [layoutConfig, setLayoutConfig] = useState({
        pageTitle: "",
        backButton: false,
        spaceDetails: null,
        displaySearch: false,
        displaySelector: false,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekGrid, { item: true, xs: 12, display: "flex", justifyContent: "space-between" },
            React.createElement(PeekStack, { direction: "row", spacing: 4, alignItems: "center" },
                React.createElement(AppHeader, { headerLabel: layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.pageTitle, icon: React.createElement(PeekTypography, { variant: "h1", display: "flex" },
                        React.createElement(Dedupe, null)) }),
                React.createElement(SearchText, { placeholder: intl.formatMessage(messages.dedupeUnitsSearch), searchText: searchKey, onChange: setSearchKey, fullWidth: true }))),
        React.createElement(PeekGrid, { item: true, xs: 12 },
            React.createElement(RefetchProvider, null,
                React.createElement(Outlet, { context: { setLayoutConfig, searchKey: debouncedSearchKey } })))));
};
